import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'momentFormat' })
export class MomentFormatPipe implements PipeTransform {
    transform(value:string, format: string) {
        if (!value) {
            return '';
        }

        return DateTime.fromISO(value).toFormat(format);
    }
}
